export default __webpack_public_path__ + "static/media/logoTextDark.405436b7.svg";